import React, { useEffect, useState } from "react";
import { Step } from "./Step";
import "./styles.css";
export var Stepper = React.memo(function (_a) {
    var step = _a.activeStep, steps = _a.steps;
    var _b = useState(step), activeStep = _b[0], setActiveStep = _b[1];
    useEffect(function () {
        setActiveStep(step);
    }, [step]);
    return (React.createElement("div", { className: "w-100" },
        React.createElement("div", { className: "stepper-horizontal" }, React.Children.map(steps, function (child, index) {
            if (!React.isValidElement(child))
                return null;
            var _a = child === null || child === void 0 ? void 0 : child.props, labelColor = _a.labelColor, Icon = _a.Icon, circleColor = _a.circleColor, label = _a.label;
            return (React.createElement(Step, { key: "step-" + index, label: label, active: activeStep === index, done: activeStep > index, isFirst: index === 0, isLast: index === React.Children.toArray(steps).length - 1, Icon: function () {
                    if (typeof Icon === "function")
                        return Icon({
                            active: activeStep === index,
                            done: activeStep > index,
                        });
                    return index + 1;
                }, circleColor: circleColor, labelColor: labelColor }));
        }))));
}, function (prevProps, nextProps) {
    return prevProps.activeStep === nextProps.activeStep;
});
